import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-payment-card-detail',
  templateUrl: './payment-card-detail.component.html',
  styleUrls: ['./payment-card-detail.component.css']
})
export class PaymentCardDetailComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
